export { default } from 'web-ssr/app/common/components/ContentFooter/Container';
